import type { FC } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";

type Props = {
  /** Where the member was headed; the dialog is open while set. */
  to: string | null;
  onCancel: () => void;
  onSkip: (to: string) => void;
};

/** Confirms leaving the guided first run for another page. */
export const SkipOnboardingDialog: FC<Props> = ({ to, onCancel, onSkip }) => (
  <AlertDialog
    open={to !== null}
    onOpenChange={(open) => {
      if (!open) onCancel();
    }}
  >
    <AlertDialogContent data-testid="skip-onboarding-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Skip Setup for Now?</AlertDialogTitle>
        <AlertDialogDescription>
          Your progress is saved. Pick up where you left off anytime from the
          Get Started checklist.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogAction
          variant="secondary"
          onClick={() => {
            if (to) onSkip(to);
          }}
        >
          Skip Setup
        </AlertDialogAction>
        <AlertDialogCancel variant="primary">Keep Setting Up</AlertDialogCancel>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
